import { render, staticRenderFns } from "./Animal.vue?vue&type=template&id=06d20a99&scoped=true&"
import script from "./Animal.vue?vue&type=script&lang=js&"
export * from "./Animal.vue?vue&type=script&lang=js&"
import style0 from "./Animal.vue?vue&type=style&index=0&id=06d20a99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d20a99",
  null
  
)

export default component.exports